import React, { useEffect } from "react";
import "./modal.scss";
import CloseIcon from "../../SVG/close";

interface ModalProps {
  dialogId: string;
  onSave: () => void | Promise<void>;
  children: React.ReactNode;
  title: string;
  saveButtonText: string;
  onCancel?: () => void | Promise<void>;
  onClose?: () => void | Promise<void>;
  cancelText: string;
  heightPercentage?: number;
  showSingleButton?: boolean;
  disableSave?: boolean;
  hideFooter?: boolean;
  autoCloseOnSave?: boolean; // New prop to control auto-close behavior
}

export function Modal(props: ModalProps) {
  const handleCancel = () => {
    closeModal(props.dialogId, props.onClose);
    if (props.onCancel) {
      props.onCancel();
    }
  };

  

  useEffect(() => {
    const dialogEle = document.getElementById(props.dialogId);
    const handleClickOutside = (event: any) => {
      if (event.target === dialogEle) {
        closeModal(props.dialogId, props.onClose);
      }
    };
    
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        closeModal(props.dialogId, props.onClose);
      }
    };
    
    dialogEle?.addEventListener("click", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);
    
    return () => {
      dialogEle?.removeEventListener("click", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props.dialogId]);

  

  return (
    <>
      <dialog
        id={props.dialogId}
        className="custom-modal"
        style={{
          height: props.heightPercentage
            ? `${props.heightPercentage}%`
            : "fit-content",
        }}
      >
        <div className="custom-modal-container">
          <div className="dialog-header">
            <div className="dialog-header-title">{props.title}</div>
            <div
              className="dialog-close-button"
              onClick={() => closeModal(props.dialogId, props.onClose)}
            >
              <CloseIcon />
            </div>
          </div>
          <div className="dialog-body">{props.children}</div>
          {!props.hideFooter && (
            <div className="dialog-footer">
              {props.showSingleButton ? (
                <button
                  className="dialog-footer-button save"
                  onClick={props.onSave}
                  disabled={props.disableSave}
                >
                  {props.saveButtonText}
                </button>
              ) : (
                <>
                  <button
                    className="dialog-footer-button cancel"
                    onClick={handleCancel}
                  >
                    {props.cancelText}
                  </button>
                  <button
                    className="dialog-footer-button save"
                    onClick={props.onSave}
                    disabled={props.disableSave}
                  >
                    {props.saveButtonText}
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </dialog>
    </>
  );
}

export function openModal(arg0: string): void {
  const modalEle = document.getElementById(arg0) as HTMLDialogElement;
  modalEle.showModal();
  modalEle.classList.add("show");
}

export function closeModal(arg0: string, onCloseFunc?: any): void {
  const modalEle = document.getElementById(arg0) as HTMLDialogElement;
  if (onCloseFunc) {
    onCloseFunc();
  }
  modalEle.close();
  modalEle.classList.remove("show");
}
